import * as _ from 'lodash'
// import { getAbbreviation } from '../../helpers/state-abbreviation'
import moverHelper from '../../helpers/mover-helper'

export default {
	name: 'review',
	created () {
	
	},
	mounted () {
		console.log('im here', this.$store.getters.selectedAreas)
		// this.abbr = getAbbreviation()
		// console.log(this.abbr)
		// window.document.addEventListener('data_loaded', (e) => { 
  //     this.initData()
  //   });
		this.initData()
	},
	data () {
		return {
			polygons : {},
			excludedAreas: '',
			selectedAreas: [],
			abbr: {},
			processing: false
		}
	},
	methods: {
		initData(){
			this.selectedAreas = JSON.parse(JSON.stringify(this.$store.getters.selectedAreas));
			this.selectedAreas = _.filter(this.selectedAreas, (selected_area) => {
				return selected_area.status == 'Active';
			})
			
			_.each(this.selectedAreas, selected_areas => {
				let selected_area_codes = JSON.parse(JSON.stringify(selected_areas.area_codes))
				let codes = _.join(_.map(selected_areas.area_codes, 'area_code'), ',')
	      		selected_area_codes = _.filter(selected_area_codes, (area)=>{
	      			if(_.isEmpty(area.additional_areacodes)){
	      				return false
	      			}
	      			return true
	      		})
	      		let additonal_codes =_.join(_.map(selected_area_codes, 'additional_areacodes'), ',')
	      		let total_codes = additonal_codes ? codes + "," + additonal_codes : codes
				selected_areas.area_codes = (selected_areas.area_codes.length) == selected_areas.total_area_codes ? 'Entire State' : total_codes;
			})

			// let context = this;
			// _.forEach(context.selectedAreas,function (area,index) {
			// 	context.selectedAreas[index] = _.map(area,"area_code")
			// })

			this.excludedAreas = _.join(_.map(this.$store.getters.excludedAreas, 'abbreviation'), ', ');
			if (this.$store.getters.excludedAreas.length) {
				this.excludedAreas += ', ';
			}
			this.excludedAreas += "AK, HI, PR";
			// console.log(this.excludedAreas)
		},
		goBack(){
			this.$router.push({ name: "get-state" })	
		},
		getLeads(){
			return;
			// moverHelper.saveClientData().then(response =>{
			// 	this.$router.push({ name: "thankyou" })	
  	// 	}).catch(error => {

  	// 	})
  		let user = this.$store.getters.user;
  		if (!user.completed_process) {
  			this.updateUser();
  		}

  		this.processing = true;
  		let filter_sets = moverHelper.getFormattedData();
  		let params = {
  			'pickups': filter_sets,
  			'token': this.$store.getters.accessToken
  		};
  		console.log(params)
			let api_url = process.env.API_URL + '/filtersets';
			this.$http.post(api_url, params).then(response => {
				this.processing = false;

				// let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
				// if (user && user.id) {
				// 	user.completed_process = 1; 
				// 	localStorage.setItem('user', JSON.stringify(user));
				// 	this.$store.commit('setUser', user);
				// }

				this.$router.push({ name: "thankyou" })	
			}).catch(error => {
				this.processing = false;
				alert("Something Went Wrong")
				console.log(error);
			})
		},
		updateUser() {
			let params = {
				'token': this.$store.getters.accessToken,
				'completed_process': 1
			}
			this.$http.put(process.env.API_URL+'/user/'+this.$store.getters.clientId, params).then(response => {
				console.log('user updated successfully')
			}).catch(error => {
				console.log('user update failed', error);
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/pages/Review/review.script.js